import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReportTemplateData } from '../models/api-models';
import { getReportTemplates, isReportTemplatesLoading } from '../store/settings/selectors';
import { loadReportTemplates, loadReportTemplateVersion } from '../store/settings/actions';

export interface ReportTemplateHook {
    template: ReportTemplateData | undefined;
    loading: boolean;
}

export const useReportTemplate = (templateId: string | undefined, version: number | undefined): ReportTemplateHook => {
    const dispatch = useDispatch();
    const templates = useSelector(getReportTemplates);
    const storeLoading = useSelector(isReportTemplatesLoading);

    const template = templateId != null && version != null
        ? templates?.find(t => t.templateId === templateId && t.version === version)
        : undefined;

    useEffect(() => {
        dispatch(loadReportTemplates());
    }, [dispatch]);

    useEffect(() => {
        if (!templateId || version == null || storeLoading || template) return;
        dispatch(loadReportTemplateVersion(templateId, version));
    }, [dispatch, templateId, version, storeLoading, template]);

    return { template, loading: storeLoading };
};
